module.exports = __webpack_public_path__ + "img/retail_back.8f73a6b6.svg";